import { CaptchaState } from "state/tree/captcha";

export default {
  isLockedByCaptcha: (state: CaptchaState) => state.locked,
  getCaptchaConfig: (state: CaptchaState) => state.config,
};
